import "./About.module.css";
import Header from "@/reusable_sections/Header";
import UtilityBar from "@/pages/Home/sections/UtilityBar";
import TheNexGenMission from "./sections/TheNexGenMission";
import OurPhilosophy from "./sections/OurPhilosophy";
import ReadyToSecureYourSeedRound from "./sections/ReadyToSecureYourSeedRound";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <UtilityBar />
      <Header />
      <TheNexGenMission />
      <OurPhilosophy />
      <ReadyToSecureYourSeedRound />
      <Footer />
    </div>;
}